// Simple, consistent with invoice submit helpers

// --- constants & helpers ---
const OBJ_ID_RX = /^[0-9a-fA-F]{24}$/
const YMD_RX = /^\d{4}-\d{2}-\d{2}$/
const toStr = v => String(v ?? '').trim()
const toNonNegInt = v => {
	const n = Number(v)
	return Number.isFinite(n) && n >= 0 ? Math.trunc(n) : 0
}
const isValidYMD = s => YMD_RX.test(s) && !Number.isNaN(new Date(s).getTime())

// --- validation ---
export const validateMembership = f => {
	const errors = []

	const customerId = toStr(f.customerId)
	const customerName = toStr(f.customerName)
	const type = toStr(f.type)
	const status = toStr(f.status)
	const remainingUsage = toStr(f.remainingUsage)
	const expiryDate = toStr(f.expiryDate)

	if (!OBJ_ID_RX.test(customerId)) errors.push({ scope: 'global', message: 'Invalid customer id.' })
	if (!customerName) errors.push({ scope: 'global', message: 'Customer name is required.' })
	if (!type) errors.push({ scope: 'global', message: 'Membership type is required.' })
	if (!status) errors.push({ scope: 'global', message: 'Membership status is required.' })

	if (remainingUsage !== '') {
		const n = Number(remainingUsage)
		if (!Number.isFinite(n) || n < 0) {
			errors.push({ scope: 'global', message: 'Remaining usage must be 0 or more.' })
		}
	}

	if (expiryDate && !isValidYMD(expiryDate)) {
		errors.push({ scope: 'global', message: 'Invalid expiry date format (YYYY-MM-DD).' })
	}

	return { ok: errors.length === 0, errors }
}

// --- error HTML renderer (compact, left-aligned) ---
export const renderErrorsHTML = errors => {
	const items = errors.map(e => `<li>${e.message}</li>`).join('')
	return `<ul style="text-align:left; margin:0 0 0 6px; padding-left:14px">${items}</ul>`
}

// --- payload builder (trim + normalize) ---
export const buildMembershipPayload = f => {
	const payload = {
		customerId: toStr(f.customerId),
		customerName: toStr(f.customerName),
		type: toStr(f.type),
		status: toStr(f.status),
	}
	if (toStr(f.remainingUsage) !== '') payload.remainingUsage = toNonNegInt(f.remainingUsage)
	if (toStr(f.expiryDate)) payload.expiryDate = toStr(f.expiryDate) // already validated as YMD
	return payload
}

// --- server call passthrough ---
export const createMembershipOnServer = (MembershipsService, payload) => MembershipsService.createMembership(payload)
